import ReactGA from 'react-ga4';

const clickedLogin = () => {
  ReactGA.event('login-success');
};

// TABS
const switchToTab1 = () => {
  ReactGA.event('switch-tab-1');
};

const switchToTab2 = () => {
  ReactGA.event('switch-tab-2');
};

const switchToTab3 = () => {
  ReactGA.event('switch-tab-3');
};

// TRANSFER
const transferSuccess = () => {
  ReactGA.event('transfer-success');
};

const transferError = () => {
  ReactGA.event('transfer-error');
};

const loadTransferNfts = (count) => {
  ReactGA.event({
    action: 'Load Transfer NFTS',
    category: 'Dashboard',
    label: count,
  });
};

// IMPORT
const importSuccess = () => {
  ReactGA.event('import-success');
};

const importError = () => {
  ReactGA.event('import-error');
};

const loadImportNfts = (count) => {
  ReactGA.event({
    action: 'Load Import NFTS',
    category: 'Dashboard',
    label: count,
  });
};

// BULLSHARK
const bullSharkSwitchWallet = () => {
  ReactGA.event('bullshark-switch-wallet');
};

const bullSharkSuccess = () => {
  ReactGA.event('bullshark-link-success');
};

const bullSharkError = () => {
  ReactGA.event('bullshark-link-error');
};

const bullsharkAlreadyConnected = () => {
  ReactGA.event('bullshark-already-connected');
};

const loadBullsharkNfts = (count) => {
  ReactGA.event({
    action: 'Load Bullshark NFTS',
    category: 'Dashboard',
    label: count,
  });
};

// DISCORD
const discordClicked = () => {
  ReactGA.event('discord-clicked');
};

// RESET PASSWORD
const resetPasswordSuccess = () => {
  ReactGA.event('reset-password-success');
};

const resetPasswordError = () => {
  ReactGA.event('reset-password-error');
};

const gaEvents = {
  clickedLogin,
  switchToTab1,
  switchToTab2,
  switchToTab3,
  transferSuccess,
  transferError,
  loadTransferNfts,
  loadImportNfts,
  importError,
  importSuccess,
  loadBullsharkNfts,
  bullsharkAlreadyConnected,
  bullSharkError,
  bullSharkSuccess,
  bullSharkSwitchWallet,
  resetPasswordError,
  resetPasswordSuccess,
  discordClicked,
};

export { gaEvents };
